import { render } from "./TrialBalance.vue?vue&type=template&id=03d614f0&ts=true"
import script from "./TrialBalance.vue?vue&type=script&lang=ts"
export * from "./TrialBalance.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/myittar_pharmacy_pos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__